declare global {
  interface Window {
    webkitAudioContext: typeof AudioContext;
  }
}

const createNoiseBuffer = (audioContext: AudioContext, duration: number) => {
  const bufferSize = audioContext.sampleRate * duration;
  const buffer = audioContext.createBuffer(1, bufferSize, audioContext.sampleRate);
  const data = buffer.getChannelData(0);
  
  for (let i = 0; i < bufferSize; i++) {
    data[i] = Math.random() * 2 - 1;
  }
  
  return buffer;
};

export const createInhaleSound = () => {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  
  // Create noise source
  const noiseBuffer = createNoiseBuffer(audioContext, 4);
  const noiseSource = audioContext.createBufferSource();
  noiseSource.buffer = noiseBuffer;
  
  // Create filters
  const filter = audioContext.createBiquadFilter();
  filter.type = 'bandpass';
  filter.frequency.setValueAtTime(800, audioContext.currentTime);
  filter.Q.setValueAtTime(1, audioContext.currentTime);
  
  // Create gain node for volume control
  const gainNode = audioContext.createGain();
  gainNode.gain.setValueAtTime(0, audioContext.currentTime);
  gainNode.gain.linearRampToValueAtTime(0.3, audioContext.currentTime + 0.5);
  gainNode.gain.linearRampToValueAtTime(0.2, audioContext.currentTime + 3.5);
  gainNode.gain.linearRampToValueAtTime(0, audioContext.currentTime + 4);
  
  // Connect nodes
  noiseSource.connect(filter);
  filter.connect(gainNode);
  gainNode.connect(audioContext.destination);
  
  // Start the sound
  noiseSource.start(audioContext.currentTime);
  noiseSource.stop(audioContext.currentTime + 4);
};

export const createHeartbeatSound = () => {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  
  const playHeartbeat = () => {
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(70, audioContext.currentTime);
    oscillator.frequency.exponentialRampToValueAtTime(50, audioContext.currentTime + 0.1);
    
    gainNode.gain.setValueAtTime(0, audioContext.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.3, audioContext.currentTime + 0.05);
    gainNode.gain.linearRampToValueAtTime(0, audioContext.currentTime + 0.2);
    
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.2);
    
    // Second beat (echo)
    setTimeout(() => {
      const echo = audioContext.createOscillator();
      const echoGain = audioContext.createGain();
      
      echo.type = 'sine';
      echo.frequency.setValueAtTime(70, audioContext.currentTime);
      echo.frequency.exponentialRampToValueAtTime(50, audioContext.currentTime + 0.1);
      
      echoGain.gain.setValueAtTime(0, audioContext.currentTime);
      echoGain.gain.linearRampToValueAtTime(0.15, audioContext.currentTime + 0.05);
      echoGain.gain.linearRampToValueAtTime(0, audioContext.currentTime + 0.2);
      
      echo.connect(echoGain);
      echoGain.connect(audioContext.destination);
      
      echo.start(audioContext.currentTime);
      echo.stop(audioContext.currentTime + 0.2);
    }, 150);
  };
  
  // Play heartbeat every second for 7 seconds
  let count = 0;
  const interval = setInterval(() => {
    playHeartbeat();
    count++;
    if (count >= 7) {
      clearInterval(interval);
    }
  }, 1000);
};

export const createExhaleSound = () => {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  
  // Create noise source
  const noiseBuffer = createNoiseBuffer(audioContext, 8);
  const noiseSource = audioContext.createBufferSource();
  noiseSource.buffer = noiseBuffer;
  
  // Create filters
  const filter = audioContext.createBiquadFilter();
  filter.type = 'lowpass';
  filter.frequency.setValueAtTime(1000, audioContext.currentTime);
  filter.frequency.exponentialRampToValueAtTime(300, audioContext.currentTime + 8);
  filter.Q.setValueAtTime(1, audioContext.currentTime);
  
  // Create gain node for volume control
  const gainNode = audioContext.createGain();
  gainNode.gain.setValueAtTime(0, audioContext.currentTime);
  gainNode.gain.linearRampToValueAtTime(0.2, audioContext.currentTime + 0.5);
  gainNode.gain.linearRampToValueAtTime(0.15, audioContext.currentTime + 7);
  gainNode.gain.linearRampToValueAtTime(0, audioContext.currentTime + 8);
  
  // Connect nodes
  noiseSource.connect(filter);
  filter.connect(gainNode);
  gainNode.connect(audioContext.destination);
  
  // Start the sound
  noiseSource.start(audioContext.currentTime);
  noiseSource.stop(audioContext.currentTime + 8);
}; 